import { PingbackConfig } from '@/models/interfaces/catalogue'

export const ALLOWED_SEPARATORS = [',', '.', '-', '+', '=', '_', '#', '~', '@', '&', '^', '|', '%', '$', '*', '<', '>']
export const SYNCABLE_SERVICES = ['shopify', 'woocommerce', 'bolcom', 'magento', 'http', 'edi', 'sync_service', 'cbhub', 'vdh', 'sinerlog']
export const SYNCABLE_SUPPLIER_SERVICES = ['http', 'msdynamics', 'sync_service']

export const DEFAULT_ORDER_EVENT_CONFIG: PingbackConfig = {
  service: undefined,
  url: undefined,
  map: undefined,
  query: undefined
}
